import { defined } from '@aid/shared/operators/defined';
import { Injectable } from '@angular/core';
import { CrudService } from '@aid/shared/services';
import { HttpClient } from '@angular/common/http';
import { ProductPartner } from '@aid/partnerships/types/classes/product-partner.class';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable()
export class ProductPartnersService extends CrudService<ProductPartner> {
  private _productPartner$ = new BehaviorSubject<ProductPartner | null>(null);

  get url() {
    return 'product-partners';
  }

  constructor(http: HttpClient) {
    super(http);
  }

  get(valueId: number, force?: boolean): Observable<ProductPartner> {
    if (!force && this._productPartner$.value) {
      return this._productPartner$.pipe(defined());
    }

    return super
      .get(valueId, force)
      .pipe(tap(productPartner => this._productPartner$.next(productPartner)));
  }

  get productPartner$(): Observable<ProductPartner | null> {
    return this._productPartner$.asObservable();
  }
}
